import { SupportDocument } from '@/app/application/support/SupportDocument';
import { Guest } from '@/app/system/guest/Guest';
import { Filter } from '@/app/system/request/Filter';
import { SupportList } from '@/app/application/support/SupportList';
import { BusEndpoint } from '@/app/application/bus/BusEndpoint';
import { AxiosResponse } from '@/app/integration/axios/list/AxiosResponse';
import { GuestDynamic } from '@/app/system/guest/GuestDynamic';
import { debug } from 'debug';
import { ResponseCached } from '@/app/system/response/ResponseCached';

const localDebug = debug('app:SupportRequestsForEmailChange');

export class SupportRequestsForEmailChange {
  public requests(guest: Guest<SupportDocument[]>, errorGuest?: Guest<any>) {
    const filter = new Filter(new SupportList(new BusEndpoint()));
    const supportCreated = new ResponseCached(new AxiosResponse(filter));
    filter.receive({
      category_code: 'PROFILE_CHANGING',
      status_code: 'NEW',
    });
    localDebug('before getting ');
    supportCreated.content(
      new GuestDynamic(response => {
        const list = response.list ?? [];
        const result = list.filter(item => {
          return item.topic.indexOf('Смена Email') === 0;
        });
        localDebug('after getting ', result);
        guest.receive(result);
      }),
      errorGuest,
    );
  }
}
